import * as React from "react";
import { BaseButton, Button, MessageBar, MessageBarType } from "@fluentui/react";

interface MessageBarProps{
  intent?: MessageBarType,
  messageInfoTitle: string | null,
  messageInfo: string
  className?: any
  onDismiss?: (ev?: React.MouseEvent<HTMLElement | BaseButton | Button>) => any;
  dismissButtonAriaLabel?: string
  actions?: JSX.Element;
  show?: boolean;
  truncated?: boolean;
  isMultiline?: boolean;
}

const Intent = (props: MessageBarProps) => {
  return (
    <div className={props.className} style={{ width: "100%" }}>
      {props.show
        ? <MessageBar
        tabIndex={0}
        messageBarType={props.intent}
        isMultiline={props.isMultiline || false}
        truncated={props.truncated}
        onDismiss={props.onDismiss}
        dismissButtonAriaLabel={props.dismissButtonAriaLabel}
        actions={props.actions}>
        {props.messageInfo}
      </MessageBar>
        : null}
    </div>
  );
};

export default Intent;
